<template>
	<div class="app-container">
		<el-card class="filter-card" shadow="hover">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<!-- <el-form-item>
					<el-button type="primary" @click="handleAddCustomer">
						<el-icon>
							<Plus />
						</el-icon> 新建客户
					</el-button>
				</el-form-item> -->
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filterForm.name" style="width: 260px" clearable placeholder="请输入客户名称"
						@clear="handleQuery">
						<template #prepend>客户名称</template>
					</el-input>
				</el-form-item>
				<!-- <el-form-item label="联系电话">
          <el-input v-model="filterForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item> -->
				<!-- <el-form-item label="客户类型">
          <el-select v-model="filterForm.type" placeholder="请选择客户类型">
            <el-option label="个人" value="personal"></el-option>
            <el-option label="企业" value="enterprise"></el-option>
          </el-select>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card class="table-card" shadow="hover">
			<el-table :data="customerList" height="calc(100vh - 320px)" style="width: 100%" stripe v-loading="loading">
				<!-- <el-table-column prop="id" label="客户ID" width="100"></el-table-column> -->
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="customerName" label="客户名称" min-width="240"></el-table-column>
				<!-- <el-table-column prop="type" label="客户类型">
          <template #default="scope">
            {{ scope.row.type === 'personal' ? '个人' : '企业' }}
          </template>
        </el-table-column> -->
				<el-table-column label="联系电话" width="160">
					<template #default="{ row }">
						{{(row.customerContacts && row.customerContacts.length > 0)   ? ((userId == row.userId || isBoss == 1)  ? row.customerContacts[0].mobile  : maskPhone(row.customerContacts[0].mobile)): '无联系方式'}}
					</template>
				</el-table-column>
				<el-table-column prop="customerContacts[0].email" label="电子邮箱" width="180"></el-table-column>
				<el-table-column prop="username" label="创建人" width="120"></el-table-column>
				<el-table-column prop="customerContacts[0].position" label="职位" width="160"></el-table-column>
				<el-table-column prop="customerContacts[0].intro" label="职位介绍" min-width="180"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="200">
					<template #default="{ row }">
						{{ formatDateTime(row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="160">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>
						<!-- <el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 添加/编辑客户对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-button size="small" type="primary" @click="handleCopy">粘贴</el-button>
			<el-form :model="customerForm" :rules="rules" ref="customerForm" label-width="auto">
				<el-form-item label="客户名称" prop="customerName">
					<el-col :span="18">
						<el-input v-model="customerForm.customerName"></el-input>
					</el-col>
				</el-form-item>
				<el-row>
					<el-col :span="14">
						<el-form-item label="所属行业" prop="industry">
							<el-col :span="20">
								<el-input v-model="customerForm.industry"></el-input>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="信用评级(1-5)" prop="creditRating">
							<el-rate v-model="customerForm.creditRating" :texts="['一星', '二星', '三星', '四星', '五星']"
								show-text />
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="客户介绍" prop="intro">
					<el-col :span="20">
						<el-input v-model="customerForm.intro" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<!-- 联系人信息 -->
				<div class="contacts-section">
					<div class="contacts-header">
						<h3>联系人信息</h3>
						<el-button type="primary" @click="addContact">
							<el-icon>
								<Plus />
							</el-icon> 增加联系人
						</el-button>
					</div>
					<div v-for="(contact, index) in customerForm.customerContacts" :key="index" class="contact-item">
						<el-form-item :label="'联系人'+(index + 1)">
							<el-col :span="21"></el-col>
							<el-col :span="3">
								<el-button type="danger" :icon="Search" @click="removeContact(index)"
									v-if="customerForm.customerContacts.length > 1">
									<el-icon>
										<Delete />
									</el-icon>
								</el-button>
							</el-col>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="'姓名'" :prop="'customerContacts.' + index + '.name'"
									:rules="{ required: true, message: '请输入联系人姓名', trigger: 'blur' }">
									<el-input v-model="contact.name"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="'手机号码'" :prop="'customerContacts.' + index + '.mobile'"
									:rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
									<el-input v-model="contact.mobile"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="'电子邮箱'" :prop="'customerContacts.' + index + '.email'">
									<el-input v-model="contact.email"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="'职位'" :prop="'customerContacts.' + index + '.position'">
									<el-input v-model="contact.position"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item :label="'职位介绍'" :prop="'customerContacts.' + index + '.intro'">
							<el-col :span="18">
								<el-input v-model="contact.intro" type="textarea" :rows="2"></el-input>
							</el-col>
						</el-form-item>
					</div>
				</div>
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitForm">保 存</el-button>
				</div>
			</template>
		</el-dialog>

		<!-- 查看客户信息对话框 -->
		<el-dialog class="mydialog" title="客户详情" v-model="viewDialogVisible" width="45vw" :close-on-click-modal="false"
			align-center>

			<el-card shadow="never">
				<el-form label-width="auto">
					<el-row>
						<el-col :span="14">
							<el-form-item label="客户名称">
								{{viewCustomer.customerName}}
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="信用评级">
								<el-rate disabled v-model="customerForm.creditRating" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="14">
							<el-form-item label="所属行业">
								{{viewCustomer.industry}}
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="创建时间">
								{{formatDateTime(viewCustomer.createTime)}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="20">
							<el-form-item label="客户介绍">
								{{customerForm.intro}}
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<el-divider />
				<div class="contact-info" v-if="viewCustomer.customerContacts && viewCustomer.customerContacts.length">
					<h3>联系人信息</h3>
					<el-table :data="viewCustomer.customerContacts" style="width: 100%" stripe>
						<el-table-column prop="name" label="姓名"></el-table-column>
						<el-table-column prop="mobile" label="手机号码">
							<template #default="{ row }">
								{{ (userId == viewCustomer.userId || isBoss == 1) ? row.mobile : maskPhone(row.mobile) }}
							</template>
						</el-table-column>
						<el-table-column prop="email" label="电子邮箱"></el-table-column>
						<el-table-column prop="position" label="职位"></el-table-column>
						<el-table-column prop="intro" label="职位介绍"></el-table-column>
					</el-table>
				</div>
			</el-card>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		getCustomerList,
		addCustomer,
		updateCustomer,
		deleteCustomer
	} from '@/api/customer'
	import dayjs from 'dayjs'

	export default {
		name: 'CustomerManagement',
		computed: {
			...mapState({
				username: state => state.user.username,
				userId: state => state.user.id,
				isBoss: state => state.user.isBoss
			})
		},
		data() {
			return {
				loading: false,
				filterForm: {
					name: '',
					phone: '',
					type: ''
				},
				customerList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				dialogTitle: '添加客户',
				viewCustomer: {},
				customerForm: {
					customerName: '',
					industry: '',
					creditRating: 3,
					intro: '',
					customerContacts: []
				},
				rules: {
					customerName: [{
						required: true,
						message: '请输入客户名称',
						trigger: 'blur'
					}],
					industry: [{
						required: true,
						message: '请输入所属行业',
						trigger: 'blur'
					}],
					intro: [{
						required: true,
						message: '请输入客户介绍',
						trigger: 'blur'
					}],
					creditRating: [{
						required: true,
						message: '请选择信用评级',
						trigger: 'change'
					}]
				}
			}
		},
		created() {
			this.fetchData()
			//console.log('isAdmin=', this.username)
		},
		methods: {
			canEdit(row) {
				return this.userId === row.userId || this.isBoss === 1
			},
			getEditButtonType(row) {
				return this.canEdit(row) ? 'primary' : 'info'
			},
			handleQuery() {
				//this.queryParams.pageNum = 1;
				this.handleSearch()
			},
			maskPhone(phone) {
				if (!phone) return ''
				return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
			},
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			async fetchData() {
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}

					// 处理日期范围参数
					if (params.dateRange && params.dateRange.length === 2) {
						params.startTime = this.formatDateTime(params.dateRange[0])
						params.endTime = this.formatDateTime(params.dateRange[1])
						delete params.dateRange
					}

					const res = await getCustomerList(params)
					// 格式化返回的日期数据
					this.customerList = res.data.records.map(item => ({
						...item,
						createTime: item.createTime ? this.formatDateTime(item.createTime) : ''
					}))
					console.log(this.customerList);

					this.total = res.data.total
				} catch (error) {
					console.error('获取客户列表失败:', error)
					this.$message.error('获取数据失败')
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					name: '',
					phone: '',
					type: ''
				}
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			handleAddCustomer() {
				this.dialogTitle = '添加客户'
				this.customerForm = {
					customerName: '',
					industry: '',
					creditRating: 3,
					intro: '',
					customerContacts: [{
						name: '',
						mobile: '',
						email: '',
						position: '',
						intro: ''
					}]
				}
				this.dialogVisible = true
				console.log('user', this.userId)
			},
			handleEdit(row) {
				this.dialogTitle = '编辑客户'
				this.customerForm = {
					...row,
					customerContacts: row.customerContacts ? [...row.customerContacts] : [{
						name: '',
						mobile: '',
						email: '',
						position: '',
						intro: ''
					}]
				}
				this.dialogVisible = true
			},
			async handleDelete(row) {
				try {
					await this.$confirm('确认删除该客户吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deleteCustomer(row.id)
					this.$message.success('删除成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除客户失败:', error)
					}
				}
			},
			async submitForm() {
				try {
					await this.$refs.customerForm.validate()

					// 处理表单数据，确保日期格式正确
					const formData = {
						...this.customerForm
					}

					// 如果有日期字段，确保格式化为后端期望的格式
					if (formData.createTime) {
						formData.createTime = this.formatDateTime(formData.createTime)
					}

					if (this.customerForm.id) {
						await updateCustomer(formData)
						this.$message.success('更新成功')
					} else {
						await addCustomer(formData)
						this.$message.success('添加成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('提交表单失败:', error)
				}
			},
			handleView(row) {
				this.viewCustomer = {
					...row,
					createTime: row.createTime ? this.formatDateTime(row.createTime) : ''
				}
				this.viewDialogVisible = true
			},
			addContact() {
				this.customerForm.customerContacts.push({
					name: '',
					mobile: '',
					email: '',
					position: '',
					intro: ''
				})
			},
			removeContact(index) {
				this.customerForm.customerContacts.splice(index, 1)
			},
			handleCopy() {
				console.log(this.customerForm);
				const id = this.customerForm.id
				navigator.clipboard.readText().then(text => {
					this.customerForm = JSON.parse(text)
					this.customerForm.id = id
					console.log(this.customerForm)
				})
			}
		}
	}
</script>

<style scoped>
	.contact-info {
		margin-top: 20px;
	}

	.contact-info h3 {
		margin-bottom: 15px;
		font-size: 16px;
		color: #303133;
	}

	.contacts-header h3 {
		margin: 0;
		font-size: 16px;
		color: #303133;
	}

	.contact-item {
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		padding: 10px 0;
		margin-bottom: 12px;
		background-color: #fafafa;
	}

	.contact-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}

	.contact-header h4 {
		margin: 0;
		font-size: 14px;
		color: #606266;
	}
</style>